import { MutableRefObject, useEffect, useRef, useState } from 'react';

const useObserverComponent = <T = any>(): { isVisible: boolean; ref: MutableRefObject<T> } => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1, // Элемент считается видимым, когда 10% его площади в зоне видимости
            },
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, []);

    return { isVisible, ref: ref as any };
};

export default useObserverComponent;
